<template>
	<div class="z-10">
		<div class="flex flex-wrap gap-1 lg:gap-2">
			<CarbarBadge
				v-if="tags?.recently_added"
				background-color="bg-blue-400"
			>
				Recently added
			</CarbarBadge>
			<CarbarBadge
				v-if="tags?.is_new && pageType === 'subscribe'"
				background-color="bg-blue-400"
			>
				Brand new
			</CarbarBadge>
			<CarbarBadge
				v-if="tags?.is_demo && pageType === 'subscribe'"
				background-color="bg-gray-600"
			>
				Demo
			</CarbarBadge>
			<CarbarBadge
				v-if="tags?.is_available_now"
				background-color="bg-gray-600"
			>
				Available now
			</CarbarBadge>
		</div>
	</div>
</template>

<script setup>
import CarbarBadge from '@/components/badges/CarbarBadge.vue'

const props = defineProps({
	tags: {
		type: Object,
		required: true,
	},
	pageType: {
		type: String,
		required: true,
	},
})
</script>
